// extracted by mini-css-extract-plugin
module.exports = {"Pagen":"pagen_Pagen__9EWX7","Current":"pagen_Current__N5GcG","ShowMore":"pagen_ShowMore__NOgWq","Buttom":"pagen_Buttom__pC54p"};